<template>
  <div
    class="flex flex-col items-center justify-center h-screen relative"
    style="z-index: 0"
  >
    <div class="background-image absolute top-0 left-0 w-full h-full">
      <!-- SVG backgrounds copied from login-form.vue -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="absolute top-0 left-0"
        width="25%"
        height="80%"
        viewBox="0 0 364 663"
        fill="none"
      >
        <path
          opacity="0.25"
          :style="[
            requestedOrganization &&
            requestedOrganization.theme &&
            requestedOrganization.theme.primary_color
              ? { color: requestedOrganization.theme.primary_color }
              : { color: '#3AF080' },
          ]"
          d="M267.362 -79.865C440.933 58.1153 418.589 276.134 -125 662.037L-112.459 588.786C80.3826 483.411 543.488 156.388 267.362 -79.865Z"
          fill="#3AF080"
        />
      </svg>
      <svg
        width="25%"
        class="absolute top-0 left-0"
        height="80%"
        viewBox="0 0 359 712"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.25"
          :style="[
            requestedOrganization &&
            requestedOrganization.theme &&
            requestedOrganization.theme.primary_color
              ? { color: requestedOrganization.theme.primary_color }
              : { color: '#3AB373' },
          ]"
          d="M242.205 -54.4781C433.553 54.178 412.512 284.485 -3.71298 711.066L-49.466 657.06C128.403 528.009 546.143 144.727 242.205 -54.4781Z"
          fill="#3AB574"
        />
      </svg>
      <div
        class="absolute top-0 right-0 flex items-start justify-end h-full w-full pointer-events-none"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25%"
          class="absolute bottom-0 right-0"
          height="80%"
          viewBox="0 0 393 730"
          fill="none"
          preserveAspectRatio="none"
        >
          <path
            opacity="0.25"
            :style="[
              requestedOrganization &&
              requestedOrganization.theme &&
              requestedOrganization.theme.primary_color
                ? { color: requestedOrganization.theme.primary_color }
                : { color: '#3AF080' },
            ]"
            d="M124.182 792.144C-87.2325 652.363 -75.4235 422.517 533.234 0.413395L504.784 274C300.609 271.371 -191.118 542.494 124.182 792.144Z"
            fill="#3AF080"
          />
        </svg>
        <svg
          width="25%"
          class="absolute bottom-0 right-0"
          height="80%"
          viewBox="0 0 351 852"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.25"
            :style="[
              requestedOrganization &&
              requestedOrganization.theme &&
              requestedOrganization.theme.primary_color
                ? { color: requestedOrganization.theme.primary_color }
                : { color: '#3AB373' },
            ]"
            d="M133.691 902C-70.1671 781.302 -85.6564 533.98 408 0V84.0574C227.292 238.342 -193.581 691.318 133.691 902Z"
            fill="#3AB574"
          />
        </svg>
      </div>
    </div>
    <div class="flex flex-col items-center justify-center z-10 gap-4">
      <div v-if="!requestedOrganization">
        <Logo type="ICON_DARK" class="login-logo" />
      </div>
      <div v-else>
        <img
          :src="requestedOrganization.logo_url"
          alt="Coach Catalyst"
          class="login-logo"
        />
      </div>
      <div
        class="w-4 h-0.5 flex-shrink-0 my-4 self-center"
        :style="[
          requestedOrganization &&
          requestedOrganization.theme &&
          requestedOrganization.theme.primary_color
            ? { background: requestedOrganization.theme.primary_color }
            : { background: '#3AB373' },
        ]"
      ></div>
      <p class="login-p">Forgot your password?</p>
      <form
        novalidate="novalidate"
        class="simple_form new_user w-full gap-4"
        id="new_user"
        @submit.prevent="onSubmit"
      >
        <input name="utf8" type="hidden" value="✓" />
        <input
          type="hidden"
          name="authenticity_token"
          :value="authenticityToken"
        />
        <fieldset class="flex flex-col items-center justify-center w-full gap-4">
          <div class="input email shadow-none w-full">
            <label class="self-stretch justify-start text-text-primary text-sm font-medium font-['Inter']">Email</label>
            <input
              tabindex="1"
              autofocus="autofocus"
              class="w-full self-stretch pl-3 pr-2 py-2 bg-surface-primary rounded-lg outline outline-1 outline-offset-[-0.50px] outline-border-secondary inline-flex justify-start items-center gap-2"
              type="email"
              v-model="email"
              placeholder="Email address"
            />
          </div>
          <div class="login-footer w-full flex flex-col items-center justify-center gap-4">
            <input
              :style="[
                requestedOrganization &&
                requestedOrganization.theme &&
                requestedOrganization.theme.primary_color
                  ? {
                      'background-color': requestedOrganization.theme.primary_color,
                    }
                  : { 'background-color': '#3AB373' },
              ]"
              type="submit"
              value="Send me reset password instructions"
              tabindex="2"
              class="btn button submit-button"
              data-disable-with="Send me reset password instructions"
            />
            <div class="w-4 h-0.5 flex-shrink-0 my-4 self-center bg-gray-500"></div>
            <div class="self-stretch h-5 text-center justify-start">
              <div class="flex text-center items-center justify-center">
                  <a href="/auth/sign_in">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                    </svg>
                  </a>

                  <span class="text-base font-normal font-['Inter'] mr-2">Back to </span>
                  <a href="/auth/sign_in" class="text-base font-semibold font-['Inter'] cursor-pointer" :style="[
                    requestedOrganization &&
                    requestedOrganization.theme &&
                    requestedOrganization.theme.primary_color
                      ? { color: requestedOrganization.theme.primary_color }
                      : { color: '#3AB373' },
                  ]">Sign in</a>

              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</template>

<script>
import ApiUrls from '../api-url';
import AuthenticationMixin from '../authentication-mixin';
import { mapGetters, mapState } from 'vuex';
import Logo from '../components/logos/Logo.vue';

export default {
  mixins: [ApiUrls, AuthenticationMixin],
  data() {
    return {
      email: '',
      authenticityToken: '',
    };
  },
  components: {
    Logo,
  },
  methods: {
    async onSubmit() {
      const formData = new FormData();
      formData.append('utf8', '✓');
      formData.append('authenticity_token', this.authenticityToken);
      formData.append('user[email]', this.email); // Devise expects user[email]

      try {
        const response = await this.axiosInstance.post(`/auth/password`, formData);

        if (response.status === 200) {
          this.$toast.show(
            'If your email exists, reset instructions were sent.',
            this.toasted_options.success
          );
          this.email = '';
        } else {
          this.$toast.show(
            'Something went wrong, try again.',
            this.toasted_options.error
          );
        }
      } catch (err) {
        this.$toast.show(
          err?.response?.data?.error || 'Failed to send reset email.',
          this.toasted_options.error
        );
      }
    },
    async getRequestedOrganization() {
      const org_subdomain = window.location.host.split('.')[0];
      const { data } = await this.axiosInstance.post(`${this.organizationUrl}requested_organization`, { org_subdomain });
      if (data.success) {
        await this.$store.commit('setRequestedOrganization', data.result);
      }
    },

  },
  async created() {
    // Fetch authenticity token from meta tag for CSRF protection
    const meta = document.querySelector('meta[name="csrf-token"]');
    this.authenticityToken = meta ? meta.getAttribute('content') : '';
    document.title = `Forgot Password | Coach Catalyst`;

    this.getRequestedOrganization().then(() => (this.loading = false));
  },
  computed: {
    ...mapState(['requestedOrganization']),
    ...mapGetters([]),
  },
  beforeCreate: function() {
    document.body.style.backgroundColor = '#F9FAFB';
  },
};
</script>

<style lang="scss"></style>
